import(/* webpackMode: "eager", webpackExports: ["Glossary"] */ "/vercel/path0/app/glossary/containers/glossary.tsx");
